import API from "../lib/api";
import { getActiveRestaurantId } from "@/lib/idProvider";


export const getAllCustomerApi = async (query, restaurant_id) => {
    try {
        const resId = restaurant_id || getActiveRestaurantId();
        if (query) {
            const { data } = await API.get( 
                `restaurant/${resId}/customers?/${query}`
            );
            return data;
        } else {
            const { data } = await API.get( 
                `restaurant/${resId}/customers`
            );
            return data;
        }

    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to fetch customers" };
    }
}

export const getCustomerByIdApi = async (id) => {
    try {
        const { data } = await API.get(
            `/restaurant/customers/${id}`
        );
        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to fetch customer" };
    }
}


export const searchCustomerApi = async (restaurantId, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurantId}/customers/search?search_term=${query}`
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to search customer" };
    }
}




export const addCustomerApi = async (customerData) => {
    try {
        
        const { data } = await API.post( 
            `/restaurant/customers`,
            {...customerData}
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to add customer" };
    }
}

export const editCustomerApi = async (customerData, id) => {
    try {
        
        const { data } = await API.put( 
            `/customers/${id}`,
            {...customerData}
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to update customer" };
    }
}


export const deleteCustomerApi = async (id) => {
    try {
        
        const { data } = await API.delete( 
            `/customers/${id}`,
            {id}
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to delete customer" };
    }
}


export const addAddressApi = async ( restaurant_id, customer_id, addressData) => {
    try {

        const { data } = await API.post(
            `restaurant/${restaurant_id}/customers/${customer_id}/add-address`,
            {...addressData}
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to add address" };
    }
}


export const updateAddressApi = async ( address_id, addressData) => {
    try {

        const { data } = await API.put(
            `restaurant/customers/addresses/${address_id}`,
            {...addressData}
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to update address" };
    }
}

export const searchCustomerAddressesByPostcodeApi = async (restaurant_id, postcode, includeGeo = true) => {
    try {
        const includeGeoValue = includeGeo ? "true" : "false";
        const { data } = await API.get(
            `restaurant/${restaurant_id}/customers/addresses/search?postcode=${postcode}&includeGeo=${includeGeoValue}`
        );

        return data;
    } catch (error) {
        return error.response?.data || { status: "failure", message: error?.message || "Failed to search addresses" };
    }
}